function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.74219 5.01562C2.88281 5.15625 3.14062 5.15625 3.28125 5.01562L4.5 3.79688L6.46875 5.78906C6.60938 5.92969 6.86719 5.92969 7.00781 5.78906L9.58594 3.21094L10.2891 3.89062C10.6406 4.26562 11.25 4.00781 11.25 3.49219V1.125C11.25 0.9375 11.0625 0.75 10.875 0.75H8.50781C7.99219 0.75 7.73438 1.35938 8.10938 1.71094L8.78906 2.41406L6.75 4.47656L4.75781 2.48438C4.61719 2.34375 4.35938 2.34375 4.21875 2.48438L2.48438 4.21875C2.34375 4.35938 2.34375 4.61719 2.48438 4.75781L2.74219 5.01562ZM11.625 7.875H1.125V0.375C1.125 0.1875 0.9375 0 0.75 0H0.375C0.164062 0 0 0.1875 0 0.375V8.25C0 8.67188 0.328125 9 0.75 9H11.625C11.8125 9 12 8.83594 12 8.625V8.25C12 8.0625 11.8125 7.875 11.625 7.875Z",
  fill: "#2B82F7"
});

var SvgIcnLineChart16Px = function SvgIcnLineChart16Px(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnLineChart16Px, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn-line-chart-16px.ee676d1e.svg";
export { ForwardRef as ReactComponent };